import {
	MedicalProcedureImport,
	MedicalProceduresImportTable,
} from '../../../../Consts/MedicalProceduresImportDefaultColumns.const';
import Checkbox from '../../../../../../Components/Base/Checkbox/Checkbox';
import styles from './ManagerInsuranceCompaniesCaseTypesImportCheckbox.module.scss';
import React from 'react';

interface Props {
	item: MedicalProcedureImport;
	selectedIds: MedicalProceduresImportTable['selectedIds'];
	toggleSelectedId: MedicalProceduresImportTable['toggleSelectedId'];
}

const ManagerInsuranceCompaniesCaseTypesImportCheckbox = ({
	item,
	selectedIds,
	toggleSelectedId,
}: Props) => {
	const isSelected = selectedIds.has(item?.id);

	return (
		<Checkbox
			// className={styles.checkboxItem}
			value={item.imported || isSelected}
			disabled={item.imported}
			onChangeExtra={(value: boolean) =>
				!item.imported && toggleSelectedId(item?.id, value)
			}
		/>
	);
};

export default ManagerInsuranceCompaniesCaseTypesImportCheckbox;
